import { useLocation } from 'react-router-dom';
import { ArrowRight, Phone, Mail, MapPin, Clock } from 'lucide-react';
import { BUSINESS } from '../data/business';
import { isEnglishPath } from '../utils/i18nRoutes';

export default function ClosingCTA() {
  const location = useLocation();
  const isEn = isEnglishPath(location.pathname);

  const eyebrow = isEn ? 'Contact' : 'Kontakt';
  const h2 = isEn ? 'Ready to reduce your operating costs?' : 'Bereit, Ihre Betriebskosten zu senken?';
  const h2Text = isEn
    ? 'Schedule a free initial consultation. We assess whether and where AI automation and cost optimization are worthwhile for your company.'
    : 'Vereinbaren Sie ein kostenloses Erstgespräch. Wir prüfen, ob und wo sich KI-Automatisierung und Kostenoptimierung für Ihr Unternehmen lohnen.';
  const contactBlockText = isEn
    ? 'Let us discuss your challenges and develop solutions together.'
    : 'Lassen Sie uns über Ihre Herausforderungen sprechen und gemeinsam Lösungen entwickeln.';
  const buttonLabel = isEn ? 'Schedule a free consultation' : 'Kostenloses Erstgespräch vereinbaren';

  const contactInfo = isEn
    ? [
        { icon: MapPin, label: 'Address', value: `${BUSINESS.name}, ${BUSINESS.address.street}, ${BUSINESS.address.postalCode} ${BUSINESS.address.locality}, ${BUSINESS.address.country}` },
        { icon: Phone, label: 'Phone', value: BUSINESS.phone, href: BUSINESS.phoneHref },
        { icon: Mail, label: 'Email', value: BUSINESS.email, href: BUSINESS.emailHref },
        { icon: Clock, label: 'Hours', value: BUSINESS.hours.label.en },
      ]
    : [
        { icon: MapPin, label: 'Adresse', value: `${BUSINESS.name}, ${BUSINESS.address.street}, ${BUSINESS.address.postalCode} ${BUSINESS.address.locality}, ${BUSINESS.address.country}` },
        { icon: Phone, label: 'Telefon', value: BUSINESS.phone, href: BUSINESS.phoneHref },
        { icon: Mail, label: 'E-Mail', value: BUSINESS.email, href: BUSINESS.emailHref },
        { icon: Clock, label: 'Öffnungszeiten', value: BUSINESS.hours.label.de },
      ];

  return (
    <section className="py-20 px-6 bg-dark text-white">
      <div className="max-w-5xl mx-auto text-center">
        <span className="eyebrow text-accent-light">{eyebrow}</span>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-2 mb-4">
          {h2}
        </h2>
        <p className="text-lg text-gray-300 max-w-2xl mx-auto mb-4">
          {h2Text}
        </p>
        <p className="text-base text-gray-400 max-w-2xl mx-auto mb-10">
          {contactBlockText}
        </p>

        <ul className="max-w-md mx-auto space-y-3 mb-10 text-left">
          {contactInfo.map((item) => (
            <li key={item.label} className="flex items-start gap-3">
              <item.icon className="w-5 h-5 text-accent-light flex-shrink-0 mt-0.5" />
              <span className="text-sm text-gray-300">
                <span className="font-semibold text-white">{item.label}: </span>
                {item.href ? (
                  <a href={item.href} className="text-accent-light hover:underline">{item.value}</a>
                ) : (
                  item.value
                )}
              </span>
            </li>
          ))}
        </ul>

        <a href="#anfrage" className="btn-primary text-base">
          {buttonLabel}
          <ArrowRight className="w-5 h-5" />
        </a>
      </div>
    </section>
  );
}
